import React from 'react'

function CarItem({car}) {

    // render JSX
    return (
        <div className="product-card">
            <div className="product-image">
                {/* car image */}
                <img className="photo-detail" src={car.PHOTO} title={car.NAME} alt="car" />
            </div>
            <div className="product-info">
                {/* car title */}
                <h5><b>{car.NAME}</b></h5>
                <p>{car.MARKA}</p>

            </div>
        </div>
    )
}

export default CarItem
